var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkills04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_2232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9046 3L1.54077 9L12.9046 15L24.2684 9L12.9046 3Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0863 11.4V16.5C6.0863 18.15 9.11665 20.25 12.9046 20.25C16.6925 20.25 19.7229 18.15 19.7229 16.5V11.4",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2684 9V18.75",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_2232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2428,
    height: 24,
    fill: "white",
    transform: "translate(0.783203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills04);
export default __webpack_public_path__ + "static/media/skills-04.95a0c309c39f970fd719a1cb813db000.svg";
export { ForwardRef as ReactComponent };